var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.doc.settlement)?_c('property',{attrs:{"name":"Поселение","value":_vm.doc.settlement}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }